import axios from '../requester';
import { API } from '../constants/api-urls';
import { DD_LOGS_CONSTS } from 'common/constants/constants';

export const getBranchesSnapshots = async params => {
  if (!params?.filter) {
    window.DD_LOGS &&
      window.DD_LOGS.logger.error(DD_LOGS_CONSTS.errors.branchesV2.noFilter, {
        payload: params
      });
    return Promise.resolve();
  }
  return axios.post(`${API.BRANCHES_PATH_V2}/snapshots/search`, params);
};

export const callBranchesCount = async requests =>
  axios.post(`${API.BRANCHES_PATH_V2}/snapshots/search/count`, { requests });

export const updateExcludeBranchCycleTime = async ({ branchId, queryParams }) =>
  axios.patch(
    `${API.BRANCHES_PATH}/${branchId}/cycle-time-exclusion?${queryParams}`
  );
